import React from "react";
import { useIdleTimer } from 'react-idle-timer';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

function IdleTimerContainer() {

  const MySwal = withReactContent(Swal)

  const PlainSwal = MySwal.mixin({
    showClass: {
      backdrop: 'swal2-noanimation', // disable backdrop animation
      popup: '',                     // disable popup animation
      icon: ''                       // disable icon animation
    },
    hideClass: {
      popup: '',                     // disable popup fade-out animation
    }
  })

  // const sessionTimeoutRef = useRef(null);

  const handleOnIdle = async () => {
    console.log("You are idle for 30 minutes");

    // sessionTimeoutRef.current = setTimeout(logOut, 5000);
    const result = await PlainSwal.fire({
      title: 'Idle Warning',
      html:  '<div><p>You\'ve been idle for 30 minutes.</p><p>Click \'OK\' to refresh the page.</p></div>',
      showCloseButton: false,
      showCancelButton: false,
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn btn-primary btn-lg me-1',
      }
    })
    
    if (result.isConfirmed) {
      if ( window.history.replaceState ) {
        window.history.replaceState( null, null, window.location.href );
      }
      window.location = window.location.href;
    }
  };

  const { start } = useIdleTimer({
    timeout: 30 * 60 * 1000,
    onIdle: handleOnIdle,
    crossTab: true,
    stopOnIdle: true
  });

  return (
    <></>
  )
}

export default IdleTimerContainer;